import { apiClient } from "../utils";
import { GetNewsletterFormsPositionsResponse } from "api/models";

export const getNewsletterFormsPositions = async (shopId: number) => {
  const { data } = await apiClient.get<GetNewsletterFormsPositionsResponse>(
    `/${shopId}/newsletter-forms/positions`
  );

  return data;
};
